import { isIsoDateString } from './is-iso-date-string.js';
export function getDatePickerDate(date, dateType) {
    if (date != null) {
        if (dateType === 'string' && isIsoDateString(date)) {
            return new Date(`${date}T00:00`);
        }
        else if (date instanceof Date && (dateType === 'date' || dateType == null)) {
            return new Date(date);
        }
    }
    // Zeroing out the timestamp is needed so we don't pollute data with timestamps from the user's local timezone.
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
}
